import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import styles from '../AiDialog.module.css';

export function DialogHeader({ title, onClose }) {
  return (
    <div className={styles.header}>
      <h6 className={styles.headerTitle}>{title}</h6>
      <button type='button' className={styles.closeBtn} onClick={onClose} aria-label='Close'>
        <CloseIcon sx={{ fontSize: 18 }} />
      </button>
    </div>
  );
}
